import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';


function normalizeCallableError(error, fallbackMessage) {
  const normalized = new Error(error?.message || fallbackMessage);
  normalized.code = error?.code || error?.details?.code || 'unknown';
  normalized.originalError = error;
  return normalized;
}

export async function createTokenPurchaseCheckout(packageId) {
  try {
    const createCheckout = httpsCallable(functions, 'createTokenPurchaseCheckout');
    const result = await createCheckout({ packageId });
    return result.data;
  } catch (error) {
    throw normalizeCallableError(error, 'Token checkout could not be started.');
  }
}
